import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const TagIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 24 24" fill="currentColor" {...props}>
    <path d="M17 5.5a1.5 1.5 0 0 1 0 3h-.01a1.5 1.5 0 0 1 0-3H17Z" />
    <path
      fillRule="evenodd"
      d="M21 1a2 2 0 0 1 2 2v8.59a2 2 0 0 1-.59 1.41l-9 9a3.43 3.43 0 0 1-4.83 0L2 15.42a3.43 3.43 0 0 1 0-4.84l9-9A2 2 0 0 1 12.41 1H21Zm0 2h-8.59l-9 9a1.43 1.43 0 0 0 0 2L10 20.58c.55.55 1.45.55 2 0l9-9V3Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default TagIcon;
